import dayjs from 'dayjs';
import { convertDateToBE } from 'utils/constants/functions';

export const VARIABLES_ROUTE_TRACKING_GET_TEAM_SALE = (params: any) => {
  const {
    page,
    page_size,
    plantId,
    routeId,
    teamSaleId,
    statusId,
    implementationDate,
    customerId,
  } = params;
  return {
    skip: (page - 1) * page_size,
    take: page_size,
    input: {
      ...(plantId && { plantId }),
      ...(routeId && { routeId }),
      ...(teamSaleId && { teamSaleId }),
      ...(teamSaleId === null && { teamSaleId: 'undefined' }),
      ...(statusId && { statusId }),
      ...(customerId && { customerId }),
      ...(implementationDate && {
        implementationDate: convertDateToBE(implementationDate),
      }),
    },
  };
};

export const VARIABLES_ROUTE_TRACKING_GET_LOCATION_TEAM_SALE = (
  params: any,
) => {
  const {
    plantId,
    implementationDate,
    routeId,
    teamSaleId,
    statusId,
    customerId,
  } = params;
  return {
    input: {
      ...(plantId && { plantId }),
      ...(implementationDate && {
        implementationDate: convertDateToBE(implementationDate),
      }),
      ...(routeId && { routeId }),
      ...(teamSaleId && { teamSaleId }),
      ...(teamSaleId === null && { teamSaleId: 'undefined' }),
      ...(statusId && { statusId }),
      ...(customerId && { customerId }),
    },
  };
};

export const VARIABLES_GET_LOCATION_CUSTOMER_BY_TEAM_SALE = (params: any) => {
  const { salePlanningId, implementationDate } = params;

  return {
    input: {
      ...(salePlanningId && { salePlanningId }),
      ...(implementationDate && {
        implementationDate: convertDateToBE(implementationDate),
      }),
    },
  };
};
